<h3>Parking lot</h3>
<div style="width: 100%;">Enter at least 3 characters in order to filter.</div>

<div style="width: 100%;">
  <kendo-grid
    [data]="view | async"
    [loading]="parkingLotService.loading"
    [scrollable]="'none'"
    [pageable]="pageableSettings"
    [pageSize]="state.take"
    [skip]="state.skip"
    [filterable]="'row'"
    [filter]="filter"
    (pageChange)="pageChange($event)"
    (filterChange)="filterChange($event)">
    <ng-template kendoGridToolbarTemplate position="top">
      <div class="d-flex justify-content-end w-100">
        <button class="btn btn-outline-secondary btn-sm" (click)="refreshData()" title="Refresh">
          <i class="fa fa-rotate-right" aria-hidden="true"></i> Refresh
        </button>
      </div>
    </ng-template>
    <ng-template kendoGridLoadingTemplate>
      <div class="d-flex justify-content-center align-items-center" style="height: 60px;">
        <div class="spinner-border alfalaval-blue-color" role="status"></div>
      </div>
    </ng-template>
    <kendo-grid-column field="itemId" title="Item ID" [width]="150">
      <ng-template kendoGridCellTemplate let-dataItem>
        @if (canViewItem(dataItem)) {
          <a
            href="javascript:void(0)"
            class="item-link"
            (click)="viewItem(dataItem.itemId)"
            title="View original item">
            {{ dataItem.itemId }}
          </a>
        } @else {
          <span>{{ dataItem.itemId }}</span>
        }
      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell
          [column]="column"
          [filter]="filter"
          operator="contains"
          [showOperators]="false">
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="replacedByItemId" title="Replaced by Item ID" [width]="160">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell
          [column]="column"
          [filter]="filter"
          operator="contains"
          [showOperators]="false">
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="isParked" title="Is Parked" [width]="100">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.isParked ? 'YES' : 'NO' }}
      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column" let-filterService="filterService">
        <select
          class="form-select form-select-sm"
          [ngModel]="getFilterValue(filter, column.field)"
          (ngModelChange)="onIsParkedFilterChange($event, filterService, filter, column.field)">
          <option value="">All</option>
          <option value="true">YES</option>
          <option value="false">NO</option>
        </select>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="parkedReason" title="Parked Reason">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column" let-filterService="filterService">
        <select
          class="form-select form-select-sm"
          [ngModel]="getFilterValue(filter, 'parkedReasonCode')"
          (ngModelChange)="onParkedReasonFilterChange($event, filterService, filter)">
          <option value="">All</option>
          @for (opt of parkedReasonDropdownOptions; track opt.value) {
            <option [value]="opt.value">{{ opt.text }}</option>
          }
        </select>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="releasedOn" title="Released On" [width]="180" [filterable]="false"></kendo-grid-column>
    <kendo-grid-column field="messageType" title="Message Type" [width]="160" [filterable]="false"></kendo-grid-column>
    <kendo-grid-column field="source" title="Source" [width]="140" [filterable]="false"></kendo-grid-column>
    <kendo-grid-column field="createdDateTime" title="Created Date" [width]="170" [filterable]="false"></kendo-grid-column>
    <kendo-grid-column field="updateDateTime" title="Update Date" [width]="170" [filterable]="false"></kendo-grid-column>
    <kendo-grid-column title="" [width]="55" [filterable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        <button class="btn btn-outline-secondary btn-sm" (click)="openViewModal(dataItem)" title="View">
          <i class="fa fa-magnifying-glass" aria-hidden="true"></i>
        </button>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
</div>
